import { useTranslation } from "react-i18next";
import { FileSpreadsheet, FileText, RefreshCw } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { exportPurchaseReport } from "../../api/purchases";

// جسم التقرير: العنوان + تصدير PDF/Excel + تحديث + بطاقات مؤشرات + جدول كامل.
export const ReportBody = ({ kind, data, params, onRefresh, busy }) => {
  const { t, i18n } = useTranslation();

  return (
    <NeuCard className="grid gap-4 p-4" data-testid="report-body">
      <div className="flex flex-wrap items-center gap-3">
        <p className="min-w-0 flex-1 truncate text-sm font-bold">
          {data?.title || t(`purchases.reports.${kind}`)}
        </p>
        <button type="button" data-testid="report-export-excel"
                onClick={() => exportPurchaseReport(kind, "xlsx", { ...params, lang: i18n.language })}
                className="flex items-center gap-1.5 rounded-xl px-3 py-2 text-[11px] font-bold text-emerald-600 shadow-neu-sm">
          <FileSpreadsheet className="h-4 w-4" /> Excel
        </button>
        <button type="button" data-testid="report-export-pdf"
                onClick={() => exportPurchaseReport(kind, "pdf", { ...params, lang: i18n.language })}
                className="flex items-center gap-1.5 rounded-xl px-3 py-2 text-[11px] font-bold text-destructive shadow-neu-sm">
          <FileText className="h-4 w-4" /> PDF
        </button>
        <button type="button" data-testid="report-refresh" onClick={onRefresh}
                className="rounded-xl p-2 text-muted-foreground shadow-neu-sm hover:text-primary">
          <RefreshCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} />
        </button>
      </div>

      {data?.supplier_name ? (
        <p className="text-base font-bold" data-testid="report-subject">{data.supplier_name}</p>
      ) : null}

      {data?.kpis?.length ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="report-kpis">
          {data.kpis.map((kpi) => (
            <div key={kpi.key} className="rounded-2xl p-4 text-center shadow-neu-in"
                 data-testid={`report-kpi-${kpi.key}`}>
              <p className="text-[11px] font-bold text-muted-foreground">
                {t(`purchases.reports.kpi.${kpi.key}`, kpi.key)}
              </p>
              <p className="num font-mono text-lg font-black text-primary">
                {data.currency && String(kpi.value).match(/[\d.]/) && String(kpi.value).includes(".")
                  ? `${data.currency} ${kpi.value}` : kpi.value}
              </p>
            </div>
          ))}
        </div>
      ) : null}

      {!data?.rows?.length ? (
        <p className="py-6 text-center text-sm text-muted-foreground" data-testid="report-empty">
          {t("purchases.reports.noData")}
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="report-table">
            <thead>
              <tr className="border-b border-border/60 text-[11px] font-bold text-muted-foreground">
                {data.heads.map((head, index) => (
                  <th key={index} className="whitespace-nowrap px-3 py-2.5 text-start">{head}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row, rowIndex) => (
                <tr key={rowIndex} data-testid={`report-row-${rowIndex}`}
                    className="border-b border-border/40 last:border-0 hover:bg-primary/5">
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex}
                        className={`whitespace-nowrap px-3 py-2.5 ${
                          cellIndex === 0 ? "font-bold" : "num font-mono text-[11px]"}`}>
                      {String(cell ?? "—")}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </NeuCard>
  );
};
